enum PlanEditResultConfigComponentsEnum {
    Tabs,
    PlanResSummaryOrderBalance,
    PlanResSummaryPlywoodBalance,
    PlanResSummaryWarehouseVeneer,
    EquipmentType,
    PlanResByShiftWarehouseVeneer,
    PlanResSummaryIndicator,
    PlanResByShiftOrderBalance,
    PlanResByShiftPlywoodBalance,
    PlanResByShiftRecommendation,
    PlanResSummaryList,
}

export default PlanEditResultConfigComponentsEnum;
